(function() {
  if (window.PMAnchorRouter && window.PMAnchorRouter.init) {
    window.PMAnchorRouter.init();
    return;
  }

  var manualInteraction = false;
  var initialized = false;
  var scrollTimer = null;

  function selectorEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return String(value).replace(/["\\#.;?+*~':!^$[\]()=>|/@]/g, '\\$&');
  }

  function getHashSlug() {
    if (!window.location || !window.location.hash) return '';

    try {
      return decodeURIComponent(window.location.hash.slice(1)).trim().toLowerCase();
    } catch (e) {
      return window.location.hash.slice(1).trim().toLowerCase();
    }
  }

  function isSafeSlug(slug) {
    return /^[a-z0-9][a-z0-9_-]{0,63}$/.test(slug);
  }

  function getStickyHeaderOffset() {
    var rootStyles = window.getComputedStyle ? window.getComputedStyle(document.documentElement) : null;
    var stickyHeight = rootStyles ? parseFloat(rootStyles.getPropertyValue('--header-sticky-height')) : 0;
    var headerHeight = rootStyles ? parseFloat(rootStyles.getPropertyValue('--header-height')) : 0;
    var stickyHeader = document.querySelector('[data-header-sticky]');
    var fallbackHeight = stickyHeader ? stickyHeader.getBoundingClientRect().height || 0 : 0;
    var measured = Math.max(
      Number.isFinite(stickyHeight) ? stickyHeight : 0,
      Number.isFinite(headerHeight) && document.body.classList.contains('has-header-sticky') ? headerHeight : 0,
      fallbackHeight
    );

    return Math.max(72, measured + 18);
  }

  function closestSection(element) {
    if (!element) return null;
    return element.closest('[data-section-type], section, [id^="shopify-section-"]') || element;
  }

  function findContactForm() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('[data-section-type="contact"]'));
    if (!forms.length) return null;

    return forms.find(function(form) {
      return !form.querySelector('.calculate-btn');
    }) || forms[forms.length - 1];
  }

  function findTarget(slug) {
    var escaped = selectorEscape(slug);
    var target = document.querySelector('[data-pm-anchor~="' + escaped + '"]');
    if (target) return target;

    target = document.getElementById(slug);
    if (target) return target;

    if (slug === 'start') {
      return document.querySelector('[data-section-type="designer-hero"]') || document.getElementById('start');
    }

    if (slug === 'help') {
      return document.querySelector('[data-designer-hero-assist-wrapper]') || document.getElementById('help');
    }

    if (slug === 'faq') {
      return document.querySelector('[id^="LandingPageFaq--"]') || document.getElementById('faq');
    }

    if (slug === 'quote') {
      return closestSection(document.querySelector('.calculate-btn'));
    }

    if (slug === 'styles') {
      return document.querySelector('.browse-all-styles');
    }

    if (slug === 'products') {
      return document.querySelector('[id^="custom-grid-"]');
    }

    if (slug === 'contact') {
      return findContactForm();
    }

    return null;
  }

  function hasToken(element, attribute, token) {
    if (!element) return false;
    return (element.getAttribute(attribute) || '').split(/\s+/).indexOf(token) !== -1;
  }

  function openAnchorPanel(element, slug) {
    if (!element) return;
    element.classList.add('is-open');
    element.hidden = false;
    element.setAttribute('aria-hidden', 'false');

    var controlsId = element.id;
    var toggleSelector = '[data-pm-anchor-toggle~="' + selectorEscape(slug) + '"]';
    if (controlsId) {
      toggleSelector += ', [aria-controls="' + selectorEscape(controlsId) + '"]';
    }

    document.querySelectorAll(toggleSelector).forEach(function(toggle) {
      toggle.setAttribute('aria-expanded', 'true');
    });
  }

  function applyAnchorState(slug, target) {
    var escaped = selectorEscape(slug);

    document.querySelectorAll('[data-pm-anchor-open~="' + escaped + '"]').forEach(function(element) {
      openAnchorPanel(element, slug);
    });

    if (hasToken(target, 'data-pm-anchor-open', slug)) {
      openAnchorPanel(target, slug);
    }

    var eventTarget = target || document;
    eventTarget.dispatchEvent(new CustomEvent('pm:anchor:activate', {
      bubbles: true,
      detail: {
        slug: slug,
        target: target || null
      }
    }));
  }

  function scrollToTarget(target, immediate) {
    if (!target) return;

    var rect = target.getBoundingClientRect();
    var top = window.pageYOffset + rect.top - getStickyHeaderOffset();

    window.scrollTo({
      top: Math.max(0, top),
      behavior: immediate || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth'
    });
  }

  function runHashScroll(options) {
    var opts = options || {};
    var slug = getHashSlug();
    if (!slug || !isSafeSlug(slug)) return false;
    if (manualInteraction && opts.pageLoad) return false;

    var target = findTarget(slug);
    if (!target) return false;

    applyAnchorState(slug, target);

    if (scrollTimer) {
      window.clearTimeout(scrollTimer);
    }

    scrollTimer = window.setTimeout(function() {
      scrollTimer = null;
      if (manualInteraction && opts.pageLoad) return;
      scrollToTarget(findTarget(slug) || target, !!opts.immediate);
    }, opts.delay === undefined ? (opts.pageLoad ? 320 : 60) : opts.delay);

    return true;
  }

  function runHashScrollRetries() {
    runHashScroll({ pageLoad: true, delay: 260 });
    [500, 1000, 1800].forEach(function(delay) {
      window.setTimeout(function() {
        runHashScroll({ pageLoad: true, delay: 0 });
      }, delay);
    });
  }

  function markManualInteraction() {
    manualInteraction = true;
    if (scrollTimer) {
      window.clearTimeout(scrollTimer);
      scrollTimer = null;
    }

    window.removeEventListener('wheel', markManualInteraction);
    window.removeEventListener('touchstart', markManualInteraction);
    window.removeEventListener('keydown', markManualInteraction);
  }

  function init() {
    if (initialized) return;
    initialized = true;

    window.addEventListener('wheel', markManualInteraction, { passive: true });
    window.addEventListener('touchstart', markManualInteraction, { passive: true });
    window.addEventListener('keydown', markManualInteraction);
    window.addEventListener('hashchange', function() {
      runHashScroll({ pageLoad: false });
    });
    window.addEventListener('load', runHashScrollRetries);
    document.addEventListener('shopify:section:load', function() {
      runHashScroll({ pageLoad: false, delay: 80 });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runHashScrollRetries);
    } else {
      runHashScrollRetries();
    }
  }

  window.PMAnchorRouter = {
    init: init,
    scrollToHash: runHashScroll
  };

  init();
})();
